import * as React from 'react'
import { MonthlyPeriodsDataSource, PeriodsDataSource, ProjectsDataSource, SurveysDataSource, HierarchyDataSource } from '../../components/ui/FiltersBar/DataSources';
import { userData } from '../../util/userData';
import { Container } from '../Container';
import { AuditLog } from './AuditLog';
import { IAuditLogProps, IAuditLogState, IReport } from './interfaces'
import { ReportListing } from './ReportListing';
import { TCBKDeposits } from './TCBKDeposits';
import { TCBKTrend } from './TCBKTrend';
import { Report } from './Report';

export class CustomReportsContainer extends Container<IAuditLogProps, IAuditLogState> {

  state: IAuditLogState = {
    AuditLogDataSource: null,
    currentReportName: '',
    currentReportObjectKey: '',
    currentReportKey: 0,
    currentReportFileName: '',
    currentReportFilters: [],
    currentProject: '',
    currentFilterValues: [],
    currentReport: null,
    displayFilters: false,
    isLoading: false
  }

  constructor(props) {
    super(props)

    this.changeReportHandler = this.changeReportHandler.bind(this)
  }

  changeReportHandler(report: IReport) {
    this.setState({ currentReport: report })
  }

  renderReport() {
    const { currentReport } = this.state
    return (
      <Report report={currentReport} />
    )
  }

  render() {
    const { currentReport } = this.state
    const reportName = (currentReport) ? currentReport.name : ''
    return (
      <div className="container">
        <header>
          <h2 className="mt-4 mb-4">
            <span>Custom Reports&nbsp;</span>
            <small className="text-muted"></small>
          </h2>
        </header>
        <div className="row" style={{ boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)' }}>
          <div className="col s12 m3 l3 xl3" style={{ minHeight: '500px', padding: '10px', borderRight: '1px solid #e7e7e7', backgroundColor: '#e7e7e7' }}>
            <ReportListing onChange={this.changeReportHandler} />
          </div>
          <div className="col s12 m9 l9 xl9" style={{ padding: '10px' }}>
            {reportName === ''
              ? <b>Click a report to the left</b>
              : this.renderReport()
            }
          </div>
        </div>
      </div>
    )
  }
}
